var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9532 12L15.2799 16.2929C15.6735 16.6834 15.6735 17.3166 15.2799 17.7071C14.8863 18.0976 14.2482 18.0976 13.8546 17.7071L8.81522 12.7071C8.42162 12.3166 8.42162 11.6834 8.81522 11.2929L13.8546 6.29289C14.2482 5.90237 14.8863 5.90237 15.2799 6.29289C15.6735 6.68342 15.6735 7.31658 15.2799 7.70711L10.9532 12Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.7432f6eb638bd1b09534d2bcccb9dea6.svg";
export { ForwardRef as ReactComponent };